export default __webpack_public_path__ + "static/media/Logo_TW.e4d166cf.png";